export class Highlights {
    private techie: boolean;
    private talentIndustries: [];
    private unicornCompanies: string[];
    private fortuneFHCompanies: string[];
    private tierOneSchools: string[];
    private showHighlights: boolean;

    constructor() {
        this.techie = false;
        this.talentIndustries = [];
        this.unicornCompanies = [];
        this.fortuneFHCompanies = [];
        this.tierOneSchools = [];
        this.showHighlights = false;
    }

    setTechie(techie: boolean) {
        this.techie = techie;
        if (techie) { this.showHighlights = true; }
    }
    get isTechie() : boolean {
        return this.techie;
    }

    setTalentIndustries(talentIndustries) {
        this.talentIndustries = talentIndustries;
        this.showHighlights = this.showHighlights || talentIndustries?.length && talentIndustries?.length > 1; 
    }
    get fetchTalentIndustries() {
        return this.talentIndustries;
    }

    setUnicornCompanies(unicornCompanies: string[]) {
        this.unicornCompanies = unicornCompanies;
        this.showHighlights = this.showHighlights || this.unicornCompanies?.length && this.unicornCompanies?.length > 0;
    }
    get fetchUnicornCompanies() {
        return this.unicornCompanies;
    }

    setTierOneSchools(tierOneSchools: string[]) {
        this.tierOneSchools = tierOneSchools;
        this.showHighlights = this.showHighlights || this.tierOneSchools?.length && this.tierOneSchools?.length > 0;
    }
    get fetchTierOneSchools() {
        return this.tierOneSchools;
    }

    setFortuneFH(fortune500: string[]) {
        this.fortuneFHCompanies = fortune500;
        this.showHighlights = this.showHighlights || this.fortuneFHCompanies?.length && this.fortuneFHCompanies?.length > 0;
    }
    get fetchFortuneFH() {
        return this.fortuneFHCompanies;
    }

    get shouldShowHighlights() {
        return this.showHighlights;
    }
}